import type { EditorNodesOptions } from 'platejs'
import type { NodeEntry } from 'slate'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { LinkElement } from './LinkElement'

export const getAllLinkNodes = (
  editor: BufferEditor,
  options: EditorNodesOptions = {},
): NodeEntry<LinkElement>[] => {
  const linkNodes = editor.api.nodes<LinkElement>({
    at: [],
    ...options,
    match: (n) => LinkElement.is(n),
    mode: 'all',
  })

  return Array.from(linkNodes)
}
